import { selectBombBomb, setBombBombStep, selectBombBombVideo } from '../../../store/slices/bombBomb'
import { useState } from 'react'
import { format } from 'date-fns'
import { SEND } from '../../../types/bombBomb'
import { HomeUser } from '../../../types/home'
import { Button, Text } from '../../../Components'
import { defineMessages, useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { selectHomeData } from '../../../store/selectors/home'
import { selectRouteKey } from '../../../store/selectors/routes'
import { selectBuyerInfo } from '../../../store/selectors/buyerInfo'

import styles from './BombBombSaveForm.module.scss'

export const MSG = defineMessages({
  homeowner: {
    id: 'BombBomb.recorder.videoTitle.homeowner',
    defaultMessage: 'Homeowner'
  },
  buyer: {
    id: 'BombBomb.recorder.videoTitle.buyer',
    defaultMessage: 'Buyer'
  },
  save: {
    id: 'BombBomb.recorder.saveButton',
    defaultMessage: 'Save video'
  },
  rerecordPre: {
    id: 'BombBomb.recorder.rerecord.pre',
    defaultMessage: 'Or click'
  },
  rerecord: {
    id: 'BombBomb.recorder.rerecord',
    defaultMessage: ' re-record '
  },
  rerecordPost: {
    id: 'BombBomb.recorder.rerecord.post',
    defaultMessage: 'on the video'
  }
})

export const BombBombSaveForm = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const home = useSelector(selectHomeData)
  const buyer = useSelector(selectBuyerInfo)
  const bombBomb = useSelector(selectBombBomb)
  const [loading, setLoading] = useState(false)
  const video = useSelector(selectBombBombVideo)
  const isHomeDigest = selectRouteKey() === 'home'
  const owners = home?.users?.map((u: HomeUser) => `${u.firstName} ${u.lastName}`).join(' & ')

  const handleSaveVideo = e => {
    setLoading(true)
    e.preventDefault()

    const digest = intl.formatMessage(isHomeDigest ? MSG.homeowner : MSG.buyer)
    const videoTitlePrefix = `Homebot ${digest}`
    const user = isHomeDigest ? owners : `${buyer.firstName} ${buyer.lastName}`
    const videoDate = format(new Date(), 'P')

    const videoTitle = `${videoTitlePrefix} - ${user} - ${videoDate}`

    bombBomb?.saveRecordedVideo(videoTitle, bombBomb.getNewVideoGuid(), video.filename, () => {
      dispatch(setBombBombStep(SEND))
      setLoading(false)
    })
  }

  return (
    <form className={styles.form} onSubmit={handleSaveVideo}>
      <Button primary type='submit' loading={loading}>
        {intl.formatMessage(MSG.save)}
      </Button>
      <Text element='span' variant='neutralCool' variantCount='700'>
        {intl.formatMessage(MSG.rerecordPre)}
        <Text element='span' variant='neutralCool' variantCount='900' weight='bold' transform='uppercase'>
          {intl.formatMessage(MSG.rerecord)}
        </Text>
        {intl.formatMessage(MSG.rerecordPost)}
      </Text>
    </form>
  )
}
